module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDY0MHY0NzkuOTk3SDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMDAyNjdmIiBkPSJNMCAwaDIxMy4zMzF2NDc5Ljk5N0gweiIvPgogICAgPHBhdGggZmlsbD0iI2YzMTgzMCIgZD0iTTQyNi42NjMgMGgyMTMuMzMxdjQ3OS45OTdINDI2LjY2M3oiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/pm.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/pm.svg
// module chunks = 0